import { IconButton, Stack } from '@mui/material';
import React from 'react';

import { ChatVerdict } from './chatStream';

type FeedbackButtonsProps = {
  verdict?: ChatVerdict;
  onVerdict: (verdict: ChatVerdict) => void;
};

function FeedbackButtons({ verdict, onVerdict }: FeedbackButtonsProps) {
  return (
    <Stack direction="row" spacing={0.5} sx={{ mt: 0.5 }}>
      <IconButton
        size="small"
        aria-label="Helpful"
        aria-pressed={verdict === 'up'}
        sx={{ opacity: verdict === 'up' ? 1 : 0.5, fontSize: 14 }}
        onClick={() => onVerdict('up')}
      >
        👍
      </IconButton>
      <IconButton
        size="small"
        aria-label="Not helpful"
        aria-pressed={verdict === 'down'}
        sx={{ opacity: verdict === 'down' ? 1 : 0.5, fontSize: 14 }}
        onClick={() => onVerdict('down')}
      >
        👎
      </IconButton>
    </Stack>
  );
}

export default FeedbackButtons;
